import { Reader } from './reader';
export function reader(fn) {
    return new Reader(fn);
}
//# sourceMappingURL=reader.factory.js.map